<div class="kz-dropdown--select"
     [ngClass]="{'kz-dropdown--select-opened': (opened$ | async) }"
     (kzClickOutside)="toggleSearch($event, true, true)"
     (click)="toggleSearch($event)">
   <ng-content select="[label]"></ng-content>
   <kz-icons name="arrowdown" class="kz-dropdown--select--icon" *ngIf="!hasSelectedItem"></kz-icons>
   <kz-icons name="cross" class="kz-dropdown--select--icon"  (click)="resetSearch($event)" *ngIf="hasSelectedItem"></kz-icons>
</div>


<div class="kz-dropdown-menu"
     [hidden]="!(opened$ | async)">
  <div class="kz-dropdown-menu-mobile-head" *ngIf="(mediaQueriesService.isMobile() | async)">
    <button class="kz-dropdown-menu-close" (click)="toggleSearch($event, true)">
      <kz-icons name="arrowleft"></kz-icons>
    </button>
  </div>
  <ng-content select="[header]"></ng-content>
  <ul class="kz-dropdown-menu--list" *ngIf="contentItems?.length">
    <ng-container *ngFor="let item of contentItems">
      <li class="kz-dropdown-menu--list--item" [ngClass]="{'kz-dropdown-menu--list--item-active': item.appFilterDropdownItemSelected}">
        <ng-container [ngTemplateOutlet]="item.itemTemplate"></ng-container>
      </li>
    </ng-container>
  </ul>
</div>
